import React from 'react';
import {CartItemDataHook} from '../../CartItem';
import s from '../../CartItem.scss';
import {LineItemModel} from '../../../../../../domain/models/LineItems/LineItem.model';
import {useTranslation} from '@wix/yoshi-flow-editor';
import {getLineItemSubscriptionFrequencyText} from '../../../../../../domain/utils/getLineItemSubscriptionFrequencyText';
import {SkeletonLineWrapper} from '../../../../Skeleton/SkeletonLine/SkeletonLineWrapper';
import {SkeletonRow} from '../../../../Skeleton/SkeletonRow/SkeletonRow';
import {Skeleton} from '../../../../Skeleton/Skeleton';
import {useControllerProps} from '../../../../../../domain/controllers/ControllerContext';

export const TotalPrice = ({
  lineItem,
  shouldShowCrossedOutPriceOnLineItemLevel,
  isItemLoading,
}: {
  lineItem: LineItemModel;
  shouldShowCrossedOutPriceOnLineItemLevel: boolean;
  isItemLoading: boolean;
}) => {
  const {changeCartLoaders} = useControllerProps().cartStore;
  const shouldDisplayFrequency =
    lineItem.attributes.subscriptionInfo &&
    lineItem.attributes.subscriptionInfo.subscriptionSettings.billingCycles !== 1;

  const {t} = useTranslation();

  if (changeCartLoaders && isItemLoading) {
    return (
      <Skeleton dataHook={CartItemDataHook.totalPriceSkeleton} className={s.totalPrice}>
        <SkeletonRow>
          <SkeletonLineWrapper size="small" />
        </SkeletonRow>
      </Skeleton>
    );
  }

  return (
    <div
      className={s.totalPrice}
      data-hook={CartItemDataHook.TotalPrice}
      data-wix-item-total-price={CartItemDataHook.TotalPrice}>
      <div className={s.priceRow}>
        {shouldShowCrossedOutPriceOnLineItemLevel &&
          lineItem.pricing.breakdown.comparePrice?.formattedConvertedAmount && (
            <div data-hook={CartItemDataHook.ComparePriceOnLineItem} className={s.comparePrice}>
              {lineItem.pricing.breakdown.comparePriceByQuantity.formattedConvertedAmount}
            </div>
          )}
        <div className={s.totalPriceText}>{lineItem.pricing.totalPrice.formattedConvertedAmount}</div>
      </div>

      {shouldDisplayFrequency && (
        <div className={s.subscriptionFrequency} data-hook={CartItemDataHook.SubscriptionFrequency}>
          {getLineItemSubscriptionFrequencyText(t, lineItem.attributes.subscriptionInfo.subscriptionSettings)}
        </div>
      )}
    </div>
  );
};
